import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import { login, saveUser } from "../../actions/AuthActions";
import { actionChangeAppProps } from "../../actions/AppAction";
import { actionChangeEmpresaProps } from "../../actions/EmpresaActions";
import RaisedButton from "material-ui/RaisedButton";
import FlatButton from "material-ui/FlatButton";
import Paper from "material-ui/Paper";
import Username from "material-ui/svg-icons/social/person";
import Password from "material-ui/svg-icons/communication/vpn-key";
import Lock from "material-ui/svg-icons/action/lock";
import { required, validateEmail, password } from "../../common/validaciones";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
	INDEX,
	PASSWORD_RECOVERY,
	EMPRESAS_NEW,
	RESEND_EMAIL_CONFIRM
} from "../../config/RoutesConstants";
import { MODE_CRU_CREATE } from "../../actions/ActionConstants";
import CircularProgress from "material-ui/CircularProgress";

class LoginIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			state: "estado",
			error: "",
			loading: false
		};
		this.recoveryPassword = this.recoveryPassword.bind(this);
		this.resendEmailConfirm = this.resendEmailConfirm.bind(this);
	}

	componentWillMount() {
		if (this.state.login) {
			this.props.history.push(INDEX);
		}
	}

	onSubmit(formValues) {
		this.setState({ error: "", loading: true });
		this.props.login(
			formValues.username,
			formValues.password,
			this.loginCallbackSucces.bind(this),
			this.loginCallbackFail.bind(this)
		);
	}

	loginCallbackFail(value) {
		this.setState({ loading: false });
		if (value) {
			this.setState({
				error: value,
				password: ""
			});
		}
	}
	loginCallbackSucces(value) {
		this.props.saveUser(value);
		this.setState({ error: "" });
		this.props.history.push("/");
	}
	recoveryPassword() {
		this.props.history.push(PASSWORD_RECOVERY);
	}
	resendEmailConfirm() {
		this.props.history.push(RESEND_EMAIL_CONFIRM);
	}
	renderConditionalLoading(loading) {
		if (false) {
			return (
				<div
					style={{
						padding: 15,
						justifyContent: "center",
						alingItems: "center"
					}}
				>
					<CircularProgress />
				</div>
			);
		} else {
			return (
				<div>
					<RaisedButton
						label="Ingresar"
						type="submit"
						primary={true}
						fullWidth
						className="top20"
						style={{ height: 40 }}
						icon={<Lock />}
					/>
					<FlatButton
						label="¿Olvidó su contraseña?"
						onClick={this.recoveryPassword}
						fullWidth
						className="top05 flatLinkButton"
						hoverColor="transparent"
						disableTouchRipple
					/>
					<FlatButton
						label="Registrarse"
						onClick={() => {
							this.props.actionChangeEmpresaProps({
								empresa: null,
								modeCRU: MODE_CRU_CREATE
							});
							this.props.history.push(EMPRESAS_NEW);
						}}
						fullWidth
						className="top05 flatLinkButton"
						hoverColor="transparent"
						disableTouchRipple
					/>
				</div>
			);
		}
	}

	render() {
		const { handleSubmit } = this.props;
		const styles = {
			iconField: {
				marginRight: 10,
				color: "#ccc"
			},
			errorStyle: {
				color: "red",
				paddingLeft: 20,
				paddingTop: 25
			}
		};
		return (
			<div className="screen-login">
				<Paper
					style={{
						flex: 1
					}}
					className="bg-login columns-column-between padding20"
				>
					<div>
						<form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
							<ReactCSSTransitionGroup
								transitionName="loginanim"
								transitionAppear={true}
								transitionAppearTimeout={1000}
								transitionEnter={false}
								transitionLeave={false}
							>
								<div className="container-login top100">
									<Paper className="paper-login">
										<div className="fields-login">
											<h1 className="bottom0" style={{}}>
												Iniciar sesión
											</h1>
										</div>
										<div className="fields-login">
											<Username style={styles.iconField} />
											<Field
												component={TextField}
												className="textField"
												name="username"
												type="text"
												fullWidth
												hintText="Usuario"
												floatingLabelText="Usuario"
												floatingLabelFixed
												validate={[required, validateEmail]}
											/>
										</div>
										<div className="fields-login">
											<Password style={styles.iconField} />
											<Field
												component={TextField}
												className="textField"
												name="password"
												type="password"
												fullWidth
												hintText="Contraseña"
												floatingLabelText="Contraseña"
												floatingLabelFixed
												validate={[required, password]}
											/>
										</div>
										<div style={styles.errorStyle}> {this.state.error} </div>
										{this.renderConditionalLoading(this.state.loading)}
									</Paper>
								</div>
							</ReactCSSTransitionGroup>
						</form>
						<FlatButton
							label="¿No llegó el mail de confirmación?"
							onClick={this.resendEmailConfirm}
							fullWidth
							className="top05"
							hoverColor="transparent"
							disableTouchRipple
							style={{ color: "blue" }}
						/>
					</div>
					<div className="text-right version-login">Versión 0.9</div>
				</Paper>
			</div>
		);
	}
}
function mapStateToProps(store) {
	return {
		loginForm: store.app.login,
		loading: store.app.loading,
		empresasList: store.empresa.empresasList,
		login: store.session.authenticated
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			login,
			actionChangeAppProps,
			actionChangeEmpresaProps,
			saveUser
		},
		dispatch
	);
}
export default reduxForm({
	form: "Login"
})(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginIndex)));



// WEBPACK FOOTER //
// ./src/screens/login/LoginIndex.js